import * as React from 'react';
import { useHistory } from 'react-router-dom';
import withStyles from 'react-jss';
import { Icon, message } from 'antd';
import { useEffect, useRef } from 'react'

import styles from './styles';
import { resetReferenceRateNotification } from 'src/api/inquiry';
import { getEditBidRoute } from '../../../routing/utils';

function CardNotification(props) {
  const { classes, className, inquiryId, onEditBid, notificationFlag, handleBidAction, mainText } = props;
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);
  const [localNotificationFlag, setLocalNotificationFlag] = React.useState<boolean>(true);
  const history: any = useHistory();
  const notificationRef = useRef<HTMLDivElement | null>(null)

  const toggleNotificationState = ():void => {
    setIsExpanded(!isExpanded);
  };

  const handleEditBid = (e):void => {
    e.preventDefault();
    if (onEditBid) {
      onEditBid();
    } else {
      changeRoute();
    }
  };

  const changeRoute = () => {
    history.push(getEditBidRoute(inquiryId));
  };

  const handleNoThanks = async () => {
    const response = await resetReferenceRateNotification({ inquiryId });
    if (response.isSuccess) {
      setLocalNotificationFlag(false);
    } else {
      message.error(response.errorMessage);
    }
  };

  useEffect(() => {
    if (notificationRef.current){
      const expandedWidth = handleBidAction ? '343px' : '240px'
      notificationRef.current.style.setProperty('--expanded-width', expandedWidth);
    }
  }, [handleBidAction])
  return (
    <>
    {
      notificationFlag && localNotificationFlag
      ?
      <div 
        ref={notificationRef}
        className={
        className
        ?
        className
        :
        `${ classes.cardNotificationContainerCollapsed } ${ isExpanded ? classes.notificationExpand : classes.notificationCollapse }` }
      >
        {
          isExpanded
          ?
          <React.Fragment>
            <span className={ classes.notificationText }>{mainText}</span>
            {handleBidAction && 
            <>
              <span className={ classes.editBid }>
                <a href="#" onClick={ e => handleEditBid(e) }>Edit Bid</a>
              </span>
              <span className={ classes.noThanks } onClick={ handleNoThanks }>No, Thanks</span>
            </>
            }
            &nbsp;&nbsp;&nbsp;
            <span className={ classes.close } onClick={ toggleNotificationState }>
              <Icon type="close-o" style={{ fontSize: 18 }} />
            </span>
          </React.Fragment>
          :
          <span className={ classes.close } onClick={ toggleNotificationState }>
            <Icon type="left-o" style={{ fontSize: 18 }} />
          </span>
        }
      </div>
    :
    null
    }
    </>
  );
}

const styledCardNotification = withStyles(styles)(CardNotification);
export default styledCardNotification;
